<template>
  <div class="RecordTableWrap">
    <el-table
      :data="tableData"
      stripe
      border
      style="width: 100%"
      class="tabWrap"
      height="90%"
      size="mini"
      :header-cell-style="{
        'background-color': '#F7F7F7',
      }"
    >
      <el-table-column
        v-for="(v, i) in tabHead"
        :key="i"
        :prop="v.prop"
        :label="v.label"
        align="center"
        :min-width="
          v.label == '计划名称' ||
          v.label == '计划执行时间' ||
          v.label == '计划巡检时间' ||
          v.label == '巡检线路' ||
          v.label == '巡检计划'
            ? ''
            : '35'
        "
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span v-if="scope.row[v.prop] == 'img'">
            <el-image
              v-for="(item, index) in scope.row.imgInfo"
              :key="index"
              style="width: 35px; height: 35px; margin-right: 5px"
              :src="item.imgUrl"
              :preview-src-list="[item.imgUrl]"
            ></el-image>
          </span>
          <span v-else>{{ scope.row[v.prop] }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 30, 50]"
      :page-size="page.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.total"
      style="margin-top: 10px; text-align: right"
    >
    </el-pagination>
  </div>
</template>

<script>
import api from "@/api";
import {
  handleWrokOrderData,
  handleRecordTableData,
} from "@/assets/utils/handleData";
export default {
  props: {
    activeName: {
      type: String,
      default: "",
    },
  },
  watch: {
    activeName: {
      handler(newvalue, oldvalue) {
        this.tableData = [];
        this.page.total = null;
        this.getTabHead();
        this.handleSizeChange(10);
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      tabHead: [],
      tableData: [],
      currentPage: 1,
      page: {
        total: null,
        size: 10,
      },
    };
  },
  methods: {
    handleSizeChange(val) {
      this.page.size = val;
      this.currentPage = 1;
      if (this.activeName === "REPAIRORDER") {
        this.getOrderData();
      } else {
        this.getRecordList();
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      if (this.activeName === "REPAIRORDER") {
        this.getOrderData();
      } else {
        this.getRecordList();
      }
    },
    async getOrderData() {
      let res = await api.authorityGetOrderByUser({
        userId: this.$store.state.user.activeUser.id ?? "",
        pageSize: this.page.size,
        page: this.currentPage - 1,
      });
      // console.log(res);
      if (res && res.data.code == 200) {
        this.tableData = handleWrokOrderData(res.data.data.data);
        this.page.total = res.data.data.totalElements;
      }
    },
    async getRecordList() {
      let res = await api.patrolRecordsGetList({
        userId: this.$store.state.user.activeUser.id ?? "",
        pageSize: this.page.size,
        page: this.currentPage - 1,
        sourceType: this.activeName,
        source: "web",
      });
      if (res && res.data.code == 200) {
        this.tableData = handleRecordTableData(res.data.data.data);
        this.page.total = res.data.data.totalElements;
      }
    },
    getTabHead() {
      if (this.activeName === "REPAIRORDER") {
        this.tabHead = [
          { label: "工单ID", prop: "id" },
          { label: "创建时间", prop: "time" },
          { label: "工单名称", prop: "description" },
          { label: "工单级别", prop: "level" },
          { label: "工单描述", prop: "remark" },
          { label: "地点", prop: "location" },
          { label: "图片", prop: "img" },
          { label: "报修人", prop: "createName" },
          { label: "联系电话", prop: "createPhone" },
          { label: "状态", prop: "setStatus" },
          { label: "处理人", prop: "handlers" },
        ];
      } else if (this.activeName === "INSPECTION") {
        this.tabHead = [
          { label: "巡检计划", prop: "planname" },
          { label: "巡检线路", prop: "routename" },
          { label: "计划巡检时间", prop: "planTime" },
          { label: "巡检点", prop: "point" },
          { label: "计划巡检人", prop: "planUser" },
          { label: "实际巡检人", prop: "realityUser" },
          { label: "巡检完成度", prop: "degreeNum" },
        ];
      } else if (this.activeName === "MAINTENANCE") {
        this.tabHead = [
          { label: "计划名称", prop: "planname" },
          { label: "设备数量", prop: "total" },
          { label: "计划执行时间", prop: "planTime" },
          { label: "设备保养进度", prop: "point" },
          { label: "计划保养人", prop: "planUser" },
          { label: "实际保养人", prop: "realityUser" },
          { label: "计划完成度", prop: "degreeNum" },
        ];
      }
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.RecordTableWrap {
  width: 100%;
  height: 100%;
}
</style>
